import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TPermission } from "../types/permissions.types";

type TPermissionsState = {
  allPermissions: TPermission[];
  rolePermissions: Record<number, Record<string, boolean>>;
};

const initialState: TPermissionsState = {
  allPermissions: [],
  rolePermissions: {},
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setAllPermissions: (state, action: PayloadAction<TPermission[]>) => {
      state.allPermissions = action.payload;
    },
    setRolePermissions: (
      state,
      action: PayloadAction<{
        roleId: number;
        permissions: Record<string, boolean>;
      }>
    ) => {
      state.rolePermissions[action.payload.roleId] = action.payload.permissions;
    },
    updateRolePermission: (
      state,
      action: PayloadAction<{
        roleId: number;
        permissionId: string;
        enabled: boolean;
      }>
    ) => {
      if (!state.rolePermissions[action.payload.roleId]) {
        state.rolePermissions[action.payload.roleId] = {};
      }
      state.rolePermissions[action.payload.roleId][
        action.payload.permissionId
      ] = action.payload.enabled;
    },
    clearRolePermissions: (state, action: PayloadAction<number>) => {
      delete state.rolePermissions[action.payload];
    },
  },
});

export const {
  setAllPermissions,
  setRolePermissions,
  updateRolePermission,
  clearRolePermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
